<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="h2f"><span class="right_1" epub:type="pagebreak" id="page_v" title="v">Contents</span></p>
<p class="tocf" id="rack"><a href="#/text/Acknowledgments#ack">Acknowledgments</a></p>
<p class="tocf" id="rintro"><a href="#/text/Introduction#intro">Introduction: Faces of Tradition in Chinese Performing Arts / Levi S. Gibbs</a></p>
<p class="toc" id="rch1"><a href="#/text/Chapter01#ch1"><b>1</b><span class="space">Grasping Intangible Heritage and Reimagining Inner Mongolia: Folk-Artist Albums and a New Logic for Musical Representation in China / Charlotte D’Evelyn</span></a></p>
<p class="toc" id="rch2"><span href="#/text/Chapter02#ch2" title="Link target outside of Sample"><b>2</b><span class="space">Chinese Singing Contests as Sites of Negotiation among Individuals and Traditions / Levi S. Gibbs</span></span></p>
<p class="toc" id="rch3"><span href="#/text/Chapter03#ch3" title="Link target outside of Sample"><b>3</b><span class="space">Dynamic Inheritance: Representative Works and the Authoring of Tradition in Chinese Dance / Emily E. Wilcox</span></span></p>
<p class="toc" id="rch4"><span href="#/text/Chapter04#ch4" title="Link target outside of Sample"><b>4</b><span class="space">Collecting Flowers, Defining a Genre: Zhang Yaxiong and the <i>Anthology of Hua’er Folksongs</i> / Sue Tuohy</span></span></p>
<p class="toc" id="rch5"><span href="#/text/Chapter05#ch5" title="Link target outside of Sample"><b>5</b><span class="space">From Field Recordings to Ethnographically Informed CDs: Curating the Sounds of Yunnan for a Niche Foreign Market / Helen Rees</span></span></p>
<p class="tocf0" id="rglo"><span href="#/text/Glossary#glo" title="Link target outside of Sample">Glossary of Selected Chinese Terms and Phrases</span></p>
<p class="tocf" id="rind"><span href="#/text/Index#ind" title="Link target outside of Sample">Index</span><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?60a54cab